import { NavigationItem } from '../context/current-context.model';
import { resolvePlacement } from './navigation-placement';

/**
 * Experimental Admin finance modules retired where a signed-off launch-track equivalent exists.
 * Active operational finance: accounting management, treasury (receipts/payouts), UFC control center.
 * Launch-track replacements: /payments/* (PSP/wallet/BNPL), /sales/*, /marketplace/*.
 */
export const RETIRED_LEGACY_EXPERIMENTAL_MODULE_KEYS = new Set<string>([
  'legacy-sales-commerce',
  'legacy-sales-reports',
  'legacy-lending-suite',
  'legacy-transaction-settlement'
]);

/** Route prefixes retired from active navigation — only where launch-track equivalent exists. */
export const RETIRED_LEGACY_EXPERIMENTAL_ROUTE_PREFIXES = [
  '/financial/sales',
  '/financial/lending',
  '/financial/transactions',
  '/financial/assets/register'
] as const;

/** Signed-off launch-track payments routes — must stay registered and navigable (Phase 8–11). */
export const LAUNCH_TRACK_PAYMENTS_ROUTES = [
  '/payments/providers',
  '/payments/intents',
  '/payments/lending',
  '/payments/wallet',
  '/payments/bnpl',
  '/payments/portfolio',
  '/payments/financial-completeness'
] as const;

const LAUNCH_TRACK_EXCEPTION_PREFIXES = ['/financial/payments/customers'] as const;

export function isLegacyExperimentalNavItem(item: NavigationItem): boolean {
  if (item.status === 'retired') {
    return true;
  }

  const placement = resolvePlacement(item);
  const moduleKey = item.moduleKeyCanonical ?? placement.moduleKey;
  if (RETIRED_LEGACY_EXPERIMENTAL_MODULE_KEYS.has(moduleKey)) {
    return true;
  }

  return isRetiredLegacyExperimentalRoute(item.route);
}

export function isRetiredLegacyExperimentalRoute(route: string): boolean {
  const normalized = route.startsWith('/') ? route : `/${route}`;

  if (LAUNCH_TRACK_EXCEPTION_PREFIXES.some(prefix => normalized === prefix || normalized.startsWith(`${prefix}/`))) {
    return false;
  }

  return RETIRED_LEGACY_EXPERIMENTAL_ROUTE_PREFIXES.some(
    prefix => normalized === prefix || normalized.startsWith(`${prefix}/`)
  );
}
